function alertMessage(message){
	if(document.querySelector('.alert_message')){
		document.querySelector('.alert_message').remove()
	}
	let messageWrap = document.createElement('div')
	messageWrap.className = 'alert_message'
	messageWrap.innerHTML = message

	document.getElementsByTagName('body')[0].appendChild(messageWrap);

	let topPos = 0;
	let elemOp = 1;

	let fadeInterval = setInterval(function(){
		if(topPos <= 64){
			topPos = topPos + 1
			document.querySelector('.alert_message').style.top = topPos + "px"
		}else{
			clearInterval(fadeInterval)
			let hold = setInterval(function(){
					clearInterval(hold)
					document.querySelector('.alert_message').remove()
			}, 2000)
		}
	}, 1)
}
export default alertMessage



// WEBPACK FOOTER //
// ./alert.js